export const selector = {
  data() {
    return {
      val: null,
    };
  },
  props: {
    value: null
  },
  watch: {
    value: function(val) {
      this.val = val;
    }
  },
  mounted() {
    this.val = this.value;
  },
  methods: {
    change(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    }
  }
}
